import { Route } from 'react-router-dom';

import { GuestDetailPage } from './pages/guest-detail-page.js';
import { GuestFormPage } from './pages/guest-form-page.js';
import { GuestListPage } from './pages/guest-list-page.js';

/**
 * The Guests module's routes.
 *
 * There is no create route yet: guests are created by the booking flow and
 * by PMS sync. The staff portal can list, view and edit existing ones.
 */
export function guestRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/guests" element={<GuestListPage />} />
      <Route path="/guests/:guestId/edit" element={<GuestFormPage />} />
      <Route path="/guests/:guestId" element={<GuestDetailPage />} />
    </>
  );
}
